module.exports = __webpack_public_path__ + "static/tiny-beautiful-things-bdb8963f4cfea14030c4b8b800f35976.jpg";